import React, { useEffect, useState, createContext, useContext } from 'react';
import { en, es } from '../translations';
type TranslationType = typeof en;
interface LanguageContextType {
  lang: 'en' | 'es';
  t: TranslationType;
}
const LanguageContext = createContext<LanguageContextType | undefined>(undefined);
export function LanguageProvider({
  children
}: {
  children: ReactNode;
}) {
  const [lang, setLang] = useState<'en' | 'es'>('en');
  useEffect(() => {
    // Auto-detect language
    const browserLang = navigator.language.toLowerCase();
    if (browserLang.startsWith('es')) {
      setLang('es');
    } else {
      setLang('en');
    }
  }, []);
  const t = lang === 'es' ? es : en;
  return <LanguageContext.Provider value={{
    lang,
    t
  }} data-id="element-193">
      {children}
    </LanguageContext.Provider>;
}
export function useLanguage() {
  const context = useContext(LanguageContext);
  if (context === undefined) {
    throw new Error('useLanguage must be used within a LanguageProvider');
  }
  return context;
}